// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StepTwo-module__userBox--vWAt3 {
    display: flex;
    flex-direction: column;
    gap: 10px;
}

.StepTwo-module__userBox--vWAt3>div {
    width: 100%;
}

.StepTwo-module__secondLineBox--uHJ4f {
    display: flex;
    gap: 10px;
    margin-top: 10px;
}

.StepTwo-module__secondLineBox--uHJ4f>div {
    width: 50%;
}

.StepTwo-module__fullWidthBox--xW5Av>div {
    width: 100%;
}

.StepTwo-module__titleBox--lffwm>h4 {
    color: var(--color-title);
    margin: 15px 0 0 0;
}

.StepTwo-module__titleBox--lffwm>p {
    color: var(--color-title);
    margin: 0 0 15px 0;
    font-size: 13px;
}

.StepTwo-module__btnBox--titpE {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;
}

.StepTwo-module__btnBoxNext--p58Hd {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.StepTwo-module__deleteIcon--Wr2EG {
    color: var(--color-error);
}

.StepTwo-module__colorBox--SAoXq,
.StepTwo-module__redBox--M9j8K {
    margin: 20px 0;
    display: flex;
    gap: 10px;
    align-content: center;
    justify-content: center;
    align-items: center;
    background-color: #e2e9ff;
    border-radius: 20px;
    padding: 5px;
}

.StepTwo-module__redBox--M9j8K {
    background-color: #ffe2e2;
}

.StepTwo-module__colorBox--SAoXq>p,
.StepTwo-module__redBox--M9j8K>p {
    margin: 0;
}
.StepTwo-module__iconRed--g8q39 {
    color: var(--color-error);
    font-size: 25px;
}

.StepTwo-module__icon--s5zIk>svg {
    color: var(--color-primary);
    font-size: 25px;
}

.StepTwo-module__dateBox--UWQnf {
    display: flex;
    gap: 10px;
}

.StepTwo-module__dateBox--UWQnf>div {
    width: 50%;
}

.StepTwo-module__checkboxBox--g2JKb {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 20px;
}

.StepTwo-module__checkboxBox--g2JKb>div {
    width: 100%;
}

.StepTwo-module__insuranceBox--tnzEV {
    margin-top: 20px;
    border-bottom: 1px solid #e2e2e2;
    border-top: 1px solid #e2e2e2;
}

.StepTwo-module__insuranceBox--tnzEV>*:nth-child(2) {
    margin-top: 10px;
}

.StepTwo-module__insuranceTitle--vccRf>h4 {
    color: var(--color-title);
    margin-bottom: 0;
}

.StepTwo-module__insuranceItem--dyykI {
    display: flex;
    gap: 10px;
    align-items: center;
}


.StepTwo-module__insuranceItem--dyykI>span {
    color: var(--color-title);
    font-weight: 500;
    width: 30%;
    font-size: 15px;
}

.StepTwo-module__insuranceItem--dyykI>p {
    margin-top: 10px;
}

.StepTwo-module__insurandBox--TiGfB {
    margin-top: 20px;
    border-bottom: 1px solid #e2e2e2;
}

.StepTwo-module__insurandItem--ySdLe {
    display: flex;
    flex-direction: column;
    width: 100%;
}


.StepTwo-module__insurandItem--ySdLe>span {
    color: var(--color-title);
    font-weight: 500;
    font-size: 15px;
}

.StepTwo-module__insurandItem--ySdLe>p {
    font-size: 15px;
}

.StepTwo-module__colorBox--SAoXq>p>span {
    font-weight: bold;
    color: var(--color-primary);
}

.StepTwo-module__infoText--CUvkk>p {
    width: 100%;
    font-size: 14px;
    margin-top: 0;
}

.StepTwo-module__infoText--CUvkk>span,
.StepTwo-module__infoText--CUvkk>p>span {
    font-size: 14px;
    font-weight: bold;
    color: var(--color-primary);
    overflow-wrap: break-word;
    word-wrap: break-word;
}

.StepTwo-module__IDClientBox--eO1Ku {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin-top: 10px;
}

.StepTwo-module__clientId--cw2uI {
    width: 100%;
}

.StepTwo-module__errorGenderBox--SNtWc {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.StepTwo-module__errorBox--bdtVX {
    display: flex;
    color: red;
}

.StepTwo-module__linkAppBox--xquqN {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-top: 20px;
}

.StepTwo-module__errorBoxGender--FIZli {
    display: flex;
    flex-direction: column;
}`, "",{"version":3,"sources":["webpack://./src/features/mite-policy/step-2/StepTwo.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,cAAc;IACd,aAAa;IACb,SAAS;IACT,qBAAqB;IACrB,uBAAuB;IACvB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,SAAS;AACb;AACA;IACI,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;;AAGA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,UAAU;IACV,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;;AAGA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,eAAe;IACf,aAAa;AACjB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,UAAU;AACd;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;AAC1B","sourcesContent":[".userBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n}\r\n\r\n.userBox>div {\r\n    width: 100%;\r\n}\r\n\r\n.secondLineBox {\r\n    display: flex;\r\n    gap: 10px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.secondLineBox>div {\r\n    width: 50%;\r\n}\r\n\r\n.fullWidthBox>div {\r\n    width: 100%;\r\n}\r\n\r\n.titleBox>h4 {\r\n    color: var(--color-title);\r\n    margin: 15px 0 0 0;\r\n}\r\n\r\n.titleBox>p {\r\n    color: var(--color-title);\r\n    margin: 0 0 15px 0;\r\n    font-size: 13px;\r\n}\r\n\r\n.btnBox {\r\n    display: flex;\r\n    justify-content: flex-end;\r\n    margin-top: 20px;\r\n}\r\n\r\n.btnBoxNext {\r\n    display: flex;\r\n    justify-content: space-between;\r\n    margin-top: 20px;\r\n}\r\n\r\n.deleteIcon {\r\n    color: var(--color-error);\r\n}\r\n\r\n.colorBox,\r\n.redBox {\r\n    margin: 20px 0;\r\n    display: flex;\r\n    gap: 10px;\r\n    align-content: center;\r\n    justify-content: center;\r\n    align-items: center;\r\n    background-color: #e2e9ff;\r\n    border-radius: 20px;\r\n    padding: 5px;\r\n}\r\n\r\n.redBox {\r\n    background-color: #ffe2e2;\r\n}\r\n\r\n.colorBox>p,\r\n.redBox>p {\r\n    margin: 0;\r\n}\r\n.iconRed {\r\n    color: var(--color-error);\r\n    font-size: 25px;\r\n}\r\n\r\n.icon>svg {\r\n    color: var(--color-primary);\r\n    font-size: 25px;\r\n}\r\n\r\n.dateBox {\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n.dateBox>div {\r\n    width: 50%;\r\n}\r\n\r\n.checkboxBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    margin-top: 20px;\r\n}\r\n\r\n.checkboxBox>div {\r\n    width: 100%;\r\n}\r\n\r\n.insuranceBox {\r\n    margin-top: 20px;\r\n    border-bottom: 1px solid #e2e2e2;\r\n    border-top: 1px solid #e2e2e2;\r\n}\r\n\r\n.insuranceBox>*:nth-child(2) {\r\n    margin-top: 10px;\r\n}\r\n\r\n.insuranceTitle>h4 {\r\n    color: var(--color-title);\r\n    margin-bottom: 0;\r\n}\r\n\r\n.insuranceItem {\r\n    display: flex;\r\n    gap: 10px;\r\n    align-items: center;\r\n}\r\n\r\n\r\n.insuranceItem>span {\r\n    color: var(--color-title);\r\n    font-weight: 500;\r\n    width: 30%;\r\n    font-size: 15px;\r\n}\r\n\r\n.insuranceItem>p {\r\n    margin-top: 10px;\r\n}\r\n\r\n.insurandBox {\r\n    margin-top: 20px;\r\n    border-bottom: 1px solid #e2e2e2;\r\n}\r\n\r\n.insurandItem {\r\n    display: flex;\r\n    flex-direction: column;\r\n    width: 100%;\r\n}\r\n\r\n\r\n.insurandItem>span {\r\n    color: var(--color-title);\r\n    font-weight: 500;\r\n    font-size: 15px;\r\n}\r\n\r\n.insurandItem>p {\r\n    font-size: 15px;\r\n}\r\n\r\n.colorBox>p>span {\r\n    font-weight: bold;\r\n    color: var(--color-primary);\r\n}\r\n\r\n.infoText>p {\r\n    width: 100%;\r\n    font-size: 14px;\r\n    margin-top: 0;\r\n}\r\n\r\n.infoText>span,\r\n.infoText>p>span {\r\n    font-size: 14px;\r\n    font-weight: bold;\r\n    color: var(--color-primary);\r\n    overflow-wrap: break-word;\r\n    word-wrap: break-word;\r\n}\r\n\r\n.IDClientBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    margin-top: 10px;\r\n}\r\n\r\n.clientId {\r\n    width: 100%;\r\n}\r\n\r\n.errorGenderBox {\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: flex-end;\r\n}\r\n\r\n.errorBox {\r\n    display: flex;\r\n    color: red;\r\n}\r\n\r\n.linkAppBox {\r\n    display: flex;\r\n    gap: 10px;\r\n    justify-content: center;\r\n    margin-top: 20px;\r\n}\r\n\r\n.errorBoxGender {\r\n    display: flex;\r\n    flex-direction: column;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"userBox": `StepTwo-module__userBox--vWAt3`,
	"secondLineBox": `StepTwo-module__secondLineBox--uHJ4f`,
	"fullWidthBox": `StepTwo-module__fullWidthBox--xW5Av`,
	"titleBox": `StepTwo-module__titleBox--lffwm`,
	"btnBox": `StepTwo-module__btnBox--titpE`,
	"btnBoxNext": `StepTwo-module__btnBoxNext--p58Hd`,
	"deleteIcon": `StepTwo-module__deleteIcon--Wr2EG`,
	"colorBox": `StepTwo-module__colorBox--SAoXq`,
	"redBox": `StepTwo-module__redBox--M9j8K`,
	"iconRed": `StepTwo-module__iconRed--g8q39`,
	"icon": `StepTwo-module__icon--s5zIk`,
	"dateBox": `StepTwo-module__dateBox--UWQnf`,
	"checkboxBox": `StepTwo-module__checkboxBox--g2JKb`,
	"insuranceBox": `StepTwo-module__insuranceBox--tnzEV`,
	"insuranceTitle": `StepTwo-module__insuranceTitle--vccRf`,
	"insuranceItem": `StepTwo-module__insuranceItem--dyykI`,
	"insurandBox": `StepTwo-module__insurandBox--TiGfB`,
	"insurandItem": `StepTwo-module__insurandItem--ySdLe`,
	"infoText": `StepTwo-module__infoText--CUvkk`,
	"IDClientBox": `StepTwo-module__IDClientBox--eO1Ku`,
	"clientId": `StepTwo-module__clientId--cw2uI`,
	"errorGenderBox": `StepTwo-module__errorGenderBox--SNtWc`,
	"errorBox": `StepTwo-module__errorBox--bdtVX`,
	"linkAppBox": `StepTwo-module__linkAppBox--xquqN`,
	"errorBoxGender": `StepTwo-module__errorBoxGender--FIZli`
};
export default ___CSS_LOADER_EXPORT___;
